import React, { useState, useEffect } from "react";
import { getContentByType } from "../../../utils/API/getStaticPages";
import { useDispatch } from "react-redux";
import { Skeleton } from "antd";
const FaqBody = () => {
  const dispatch = useDispatch();
  const [termsContent, setTermsContent] = useState(null);
  useEffect(() => {
    const fetchTermsContent = async () => {
      try {
        const response = await getContentByType("faq", dispatch);

        if (response && response.content) {
          setTermsContent(response.content.pageContent);
        } else {
          console.error("Invalid response format:", response);
        }
      } catch (error) {
        console.error("Error fetching terms content:", error);
      }
    };
    fetchTermsContent();
  }, []);

  if (!termsContent) {
    return (
      <div className="flex flex-col gap-y-4 m-4 px-24">
        <Skeleton.Button block={true} active={true} />
        <Skeleton.Button block={true} active={true} />
        <Skeleton.Button block={true} active={true} />
        <Skeleton.Button block={true} active={true} />
      </div>
    );
  }

  return (
    <>
      <div className="h-full  ">
        <div className="bg-blue-100 pt-8">
          <div
            className="flex justify-center h-[26rem] items-center pt-12 bg-cover bg-center bg-no-repeat"
            style={{
              backgroundImage: "url('/images/contactusheader.png')",
              backgroundSize: "100%",
            }}
          >
            <div className="py-20 bg-opacity-70">
              <div className="text-[80px] flex font-normal justify-center">
                 FREQUENTLY ASKED{" "}
                <span className="text-blue-800"> {" "} QUESTIONS </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="px-32 pt-12 border"
        dangerouslySetInnerHTML={{ __html: termsContent }}
      />
    </>
  );
};

export default FaqBody;
